import React from 'react'

function AuditUniverse() {
  return (
    <div>
        <h1 className='text-2xl font-bold mb-4'>Audit Universe</h1>
    </div>
  )
}

export default AuditUniverse
